import DoGuide from './DoGuide';
import * as CoreFns from '../utilities/CoreFns';
import * as EditorFunctions from '../utilities/EditorFunctions';
import TextBoxIcons from '../StockItems/TextBoxIcons';
import RightSideTableRows from '../Editor/RightSideTableRows';
import UpperPointer from './UpperPointer';
import EditBarTitleFull from './EditBarTitleFull';
import ActionList from '../Editor/ActionList';

function App(props) {

  var currentList = props.currentList;
  var error = props.error;
  var itemEdited = props.itemEdited;
  var setItemEdited = props.setItemEdited;
  var insetWidth = props.insetWidth;
  var insetHeight = props.insetHeight;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var userNos = props.userNos;
  var userID = props.userID;
  var organicChanges = props.organicChanges;
  var highlightAnItem = props.highlightAnItem;
  var doingWhat = props.doingWhat;
  var setDoingWhat = props.setDoingWhat;
  var changeTab = props.changeTab;
  var leftColRefs = props.leftColRefs
  var setLeftColRefs = props.setLeftColRefs;
  var flashHighlight = props.flashHighlight;
  var setFlashHighlight = props.setFlashHighlight;
  var addToExtraScreen = props.addToExtraScreen;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var logInState = props.logInState;
  var sessionID = props.sessionID;
  var signKey = props.signKey;
  var screenRefs = props.screenRefs;
  var setLastEdited = props.setLastEdited;

  var detailsWidth = props.detailsWidth;
  var refObject = props.refObject;
  var toggle = props.toggle;
  var setToggle = props.setToggle;
  var screenSize = props.screenSize;
  var mostRecentFont = props.mostRecentFont;
  var setMostRecentFont = props.setMostRecentFont;
  var mostRecentColor = props.mostRecentColor;
  var setMostRecentColor = props.setMostRecentColor;
  var pieces = props.editButtons;
  var centerZoom = props.centerZoom;
  var fakeInternalVariables = props.fakeInternalVariables;
  var chains = props.chains;

  var guideItem = '';
  var gotUp = false;

  function lame(){
    return <div className='container' style={{textAlign:'left'}}>
            <div className='container'><br/><div className='row'><center><p className='lead mb-0 explanation'>Please click on an element to edit it</p></center></div></div></div>
  }
//
  if (!itemEdited){
    return lame();
  }

  var pathDown = itemEdited.path;

  var thisItem;
  try{
    thisItem = CoreFns.goDownPath(currentList, pathDown);
  }catch(err){

  }

  if (!thisItem){
    return lame();
//
  }

  if (itemEdited.t === 'page'){
    if (pathDown[0] === 'pu'){
      guideItem = 'popUp';
    }else{
      guideItem = 'page';
    }
  }else if (itemEdited.t === 'item'){
    if (thisItem){
      guideItem = thisItem.t;
    }
  }else if (itemEdited.t === 'screen'){
    if (pathDown[0] === 'fo'){
      guideItem = 'footer';
    }else{
      guideItem = itemEdited.t;
    }
  }else if (itemEdited.t === 'alert' || itemEdited.t === 'asset' || itemEdited.t === 'navBar'){
    guideItem = itemEdited.t;
  }

  var editorBar = pieces.map((anItem, index)=>{
    return <TextBoxIcons key={index} anItem={anItem} isShowingSomeDropDown={isShowingSomeDropDown} error={error} itemEdited={itemEdited} highlightAnItem={highlightAnItem}/>
  })


  var tgtDropDown = '';
  if (isShowingSomeDropDown){
    for (var i4 = 0; i4 < pieces.length; i4++){
      if (pieces[i4].h === isShowingSomeDropDown.t){
        tgtDropDown = pieces[i4];
      }
    }
  }

  var tabContents;
  var tabTitle = null;
  if (tgtDropDown){
    var thingsToChange = [];
    if (isShowingSomeDropDown && (isShowingSomeDropDown.t === 'click' || isShowingSomeDropDown.t === 'change')){
      var path = pathDown.concat(['oc', isShowingSomeDropDown.t]);
      tabContents = <ActionList chains={chains} width={detailsWidth - 20} startPath={path} currentList={currentList} error={error} organicChanges={organicChanges} addToExtraScreen={addToExtraScreen}  userNos={userNos}  doingWhat={doingWhat} setDoingWhat={setDoingWhat} changeTab={changeTab} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs} />
//          
    }else if (isShowingSomeDropDown && isShowingSomeDropDown.t === 'color'){
      thingsToChange = [{t:'fontColor'}];
    }else if (isShowingSomeDropDown && isShowingSomeDropDown.t === 'fontSize'){
      thingsToChange = [{t:'fontSize'}];
    }else if (isShowingSomeDropDown && isShowingSomeDropDown.t === 'fontFamily'){
      thingsToChange = [{t:'fontFamily'}];
    }else{
      thingsToChange = EditorFunctions.directoryOfThingsToChange(chains, changeTab, isShowingSomeDropDown, currentList, pathDown, insetWidth, insetHeight, organicChanges, isClickingOnContentDiv, logInState, sessionID, signKey, userID, userNos, setItemEdited, setIsShowingSomeDropDown, screenRefs);
    }

    var tabTitlePiece = EditorFunctions.getHintNames(isShowingSomeDropDown.t);
    tabTitle = <p className='lead mb-0' style={{color:'yellow'}}>{tabTitlePiece}</p>
//
    if (pathDown && !tabContents){
      tabContents = <RightSideTableRows chains={chains} thingsToChange={thingsToChange} objPath={pathDown} organicChanges={organicChanges} currentList={currentList} setItemEdited={setItemEdited} userNos={userNos} userID={userID} error={error} itemEdited={itemEdited} refObject={refObject} isShowingSomeDropDown={isShowingSomeDropDown} setIsShowingSomeDropDown={setIsShowingSomeDropDown} addToExtraScreen={addToExtraScreen} columnWidth={detailsWidth - 60} toggle={toggle} setToggle={setToggle} insetWidth={insetWidth} insetHeight={insetHeight} screenSize={screenSize} mostRecentFont={mostRecentFont} setMostRecentFont={setMostRecentFont} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} changeTab={changeTab} screenRefs={screenRefs} doingWhat={doingWhat} setDoingWhat={setDoingWhat} highlightAnItem={highlightAnItem} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs} flashHighlight={flashHighlight} setFlashHighlight={setFlashHighlight} centerZoom={centerZoom} fakeInternalVariables={fakeInternalVariables} setLastEdited={setLastEdited}/>
      
    }
  }

//
   return <div className='container' style={{textAlign:'left'}}><br/>
            <div className='container'><div className='row'>
              <UpperPointer currentList={currentList} error={error} itemEdited={itemEdited} setItemEdited={setItemEdited} highlightAnItem={highlightAnItem} isShowingSomeDropDown={isShowingSomeDropDown} whereFrom='edit'/>
              <div className='col-6'><DoGuide addToExtraScreen={addToExtraScreen} set={{t:'topRow', guideItem, gotUp}} /></div>
              </div></div>
              <EditBarTitleFull currentList={currentList} itemEdited={itemEdited} organicChanges={organicChanges} preText='Edit '/><br/>
            <div style={{minHeight:42}} className="rdw-editor-toolbar radio-tile-group noSelect">{editorBar}</div><br/>
            {tabTitle}
            {tabContents}
      </div>
  

}

export default App;
